import * as z from 'zod';

import { auth0ScreenHintSchema } from '#utils/auth0-screen-hint.js';

/**
 * The login route's search contract. Unknown params pass through because marketing links land here carrying campaign
 * tags, which are read off the search to attribute the signup.
 */
export const logInSearchSchema = z
	.object({
		/** Forwarded to Auth0 so a link can open the signup tab instead of the login one. */
		screen_hint: auth0ScreenHintSchema.optional().catch(undefined),
	})
	.passthrough();
